/**
 * Default placeholder text to display in Search.
 * @returns "Search"
 */
export const DEFAULT_SEARCH_PLACEHOLDER: string = 'Search';

/**
 * Default timeout value for debounced behavior in Search.
 */
export const DEFAULT_DEBOUNCE_TIMEOUT: number = 300;

/**
 * Default data-testid for Search component.
 */
export const DEFAULT_SEARCH_TESTID: string = 'table-search';
